var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgK = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 24",
  viewBox: "0 0 210 179.277"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "K_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h210v179.277H0z",
  "data-name": "Rectangle 26"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23",
  style: {
    clipPath: "url(#K_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.167 65.216c.443 6.416 1 10.619 1 10.619l49-23.229 11.5-5.531 2.877-1.328a103 103 0 0 0-9.29-17.147C53.458-2.7 27.685.063 27.685.063c-10.4 15.819-9.735 48.34-8.518 65.153",
  "data-name": "Path 14"
})), /*#__PURE__*/React.createElement("path", {
  d: "M22.684 71.32a219 219 0 0 1-.524-6.311c-.944-13.044-2.082-43.859 6.37-60.424 5.447 4.525 18.234 15.942 28.177 30.982a95.4 95.4 0 0 1 8.614 15.541z",
  "data-name": "Path 15",
  style: {
    fill: "#fff"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.623 9.472a146 146 0 0 1 24.609 27.791 96 96 0 0 1 7.141 12.4L25.3 66.762c-.049-.632-.1-1.293-.145-1.979C24.29 52.891 23.24 25.9 29.623 9.472M27.684.063c-10.4 15.819-9.734 48.34-8.517 65.153.442 6.416 1 10.619 1 10.619l49-23.229a94.5 94.5 0 0 0-9.956-18.694C45.826 13.669 27.684.063 27.684.063",
  "data-name": "Path 16"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M190.837 65.216c-.443 6.416-1 10.619-1 10.619l-49-23.229-11.5-5.531-2.877-1.328a103 103 0 0 1 9.29-17.147C156.546-2.7 182.319.063 182.319.063c10.4 15.819 9.735 48.34 8.518 65.153",
  "data-name": "Path 17"
})), /*#__PURE__*/React.createElement("path", {
  d: "M144.683 51.108a95.3 95.3 0 0 1 8.6-15.521c9.955-15.055 22.744-26.477 28.192-31 8.453 16.565 7.313 47.38 6.37 60.414a222 222 0 0 1-.525 6.321z",
  "data-name": "Path 18",
  style: {
    fill: "#fff"
  }
}), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M180.38 9.471c6.382 16.43 5.333 43.423 4.471 55.332q-.07 1.019-.144 1.959l-36.077-17.1a97 97 0 0 1 7.17-12.441 145.7 145.7 0 0 1 24.58-27.75m1.939-9.408s-18.141 13.606-31.525 33.849a94.5 94.5 0 0 0-9.956 18.694l49 23.229s.553-4.2 1-10.619c1.216-16.813 1.88-49.334-8.518-65.153",
  "data-name": "Path 19"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m200.047 99.012-1.694 6.438-.509 2.2a36 36 0 0 1-1.863 5.59 74.4 74.4 0 0 1-7.794 17.621c-1.524 2.541-3.049 4.743-4.574 7.115a97.7 97.7 0 0 1-18.806 19.484 91.98 91.98 0 0 1-56.418 19.314 23 23 0 0 1-3.389-.169 23 23 0 0 1-3.389.169 13 13 0 0 1-2.54-.169 90.6 90.6 0 0 1-53.878-19.145 97.7 97.7 0 0 1-18.806-19.484c-1.524-2.372-3.05-4.574-4.574-7.115a74.5 74.5 0 0 1-7.794-17.621 36 36 0 0 1-1.863-5.59l-.509-2.2-1.694-6.438A32 32 0 0 1 13 74.106c2.033-3.049 3.9-5.929 6.1-8.809a96.8 96.8 0 0 1 40.155-31.344 77 77 0 0 1 12.369-4.575c.847-.338 1.694-.508 2.541-.847a97 97 0 0 1 9.657-1.864 74 74 0 0 1 14.909-1.355h.508a5.2 5.2 0 0 1 1.525-.17 34 34 0 0 1 4.236.17 38.6 38.6 0 0 1 6.269 0 72 72 0 0 1 14.909 1.355 86 86 0 0 1 9.488 1.864c1.016.339 1.863.509 2.71.847a77 77 0 0 1 12.369 4.575A96.8 96.8 0 0 1 190.9 65.3c2.2 2.88 4.066 5.76 6.1 8.809a32 32 0 0 1 3.05 24.906",
  "data-name": "Path 20"
})), /*#__PURE__*/React.createElement("path", {
  d: "M108.389 179.277a27 27 0 0 1-3.389-.148 27 27 0 0 1-3.389.148 16 16 0 0 1-2.793-.174 93.64 93.64 0 0 1-55.157-19.665 101 101 0 0 1-19.3-19.988l-.081-.119c-.505-.785-1.009-1.551-1.513-2.317-1.013-1.538-2.06-3.128-3.1-4.865a76.4 76.4 0 0 1-7.994-18.024 39 39 0 0 1-1.931-5.815l-.533-2.3-1.673-6.362a34.38 34.38 0 0 1 3.314-26.815l.072-.114.871-1.31c1.743-2.624 3.388-5.1 5.323-7.631a99.86 99.86 0 0 1 41.118-32.109A79 79 0 0 1 70.829 27c.477-.183.935-.321 1.343-.443.354-.106.709-.21 1.063-.352l.294-.1a99 99 0 0 1 9.877-1.91 75.5 75.5 0 0 1 15.325-1.391h.179a8.4 8.4 0 0 1 1.854-.169 38 38 0 0 1 4.283.158 41 41 0 0 1 6.325.011 73.7 73.7 0 0 1 15.263 1.4 87 87 0 0 1 9.7 1.914l.123.037c.387.129.747.231 1.091.328.521.148 1.059.3 1.623.517a79.3 79.3 0 0 1 12.6 4.665A99.9 99.9 0 0 1 192.9 63.792c1.925 2.518 3.572 5 5.316 7.626l.937 1.415a34.41 34.41 0 0 1 3.309 26.841l-1.687 6.412-.491 2.129a39 39 0 0 1-1.955 5.91 76.5 76.5 0 0 1-8.018 18.063c-1.016 1.695-2.061 3.281-3.071 4.816-.507.769-1.013 1.538-1.519 2.326l-.082.12a101 101 0 0 1-19.283 19.978 93.88 93.88 0 0 1-57.963 19.849M105 174.082l.354.05a20.4 20.4 0 0 0 3.035.145 88.9 88.9 0 0 0 54.888-18.792 94.5 94.5 0 0 0 18.272-18.919c.5-.782 1.007-1.547 1.511-2.312.982-1.491 2-3.033 2.983-4.677a71.8 71.8 0 0 0 7.547-17.065l.115-.3a33.7 33.7 0 0 0 1.727-5.212l.485-2.108 1.726-6.562a29.4 29.4 0 0 0-2.766-22.892l-.83-1.249c-1.7-2.556-3.3-4.969-5.134-7.369a94.9 94.9 0 0 0-39.132-30.556l-.114-.052a74.3 74.3 0 0 0-11.967-4.427l-.254-.086a13 13 0 0 0-1.264-.4 29 29 0 0 1-1.246-.374 83 83 0 0 0-9.123-1.782l-.161-.03a69 69 0 0 0-14.385-1.3l-.208-.008a36 36 0 0 0-5.853 0l-.26.022-.259-.033a32 32 0 0 0-3.925-.15 3.8 3.8 0 0 0-.747.045l-.386.129h-.9a71 71 0 0 0-14.4 1.3l-.116.021c-3.215.509-6.231.985-9.274 1.776-.472.181-.924.316-1.328.438-.353.106-.706.208-1.058.349l-.254.086a74.4 74.4 0 0 0-11.965 4.422l-.115.052A94.87 94.87 0 0 0 21.1 66.8c-1.845 2.412-3.446 4.823-5.141 7.375l-.836 1.259a29.4 29.4 0 0 0-2.765 22.891l1.707 6.488.528 2.277a33 33 0 0 0 1.7 5.118l.115.3a71.7 71.7 0 0 0 7.523 17.026c1.012 1.686 2.029 3.231 3.013 4.726.5.762 1 1.523 1.505 2.3a94.6 94.6 0 0 0 18.288 18.94 88.6 88.6 0 0 0 52.376 18.611l.448.048a11 11 0 0 0 2.05.121 20.4 20.4 0 0 0 3.035-.145z",
  "data-name": "Path 21",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.012 115.942a6.508 6.508 0 0 1-.235-13.012l40.275-1.458h.064a6.54 6.54 0 0 1 6.615 6.274 6.51 6.51 0 0 1-6.273 6.737L9.2 115.942z",
  "data-name": "Path 22",
  style: {
    fill: "#fff"
  }
}), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M49.077 103.972a4.009 4.009 0 1 1 .293 8.013l-40.212 1.457h-.146a4.008 4.008 0 0 1-.146-8.013zm-.051-5h-.13l-40.211 1.46a9.008 9.008 0 0 0 .327 18.01h.327l40.212-1.457a9.008 9.008 0 0 0-.4-18.009z",
  "data-name": "Path 23"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13.548 143.447a6.51 6.51 0 0 1-1.523-12.838l39.124-9.409a6.6 6.6 0 0 1 1.514-.177 6.509 6.509 0 0 1 1.54 12.836l-39.125 9.413a6.8 6.8 0 0 1-1.53.179",
  "data-name": "Path 24",
  style: {
    fill: "#fff"
  }
}), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M52.663 123.519a4.008 4.008 0 0 1 .95 7.906l-39.12 9.412a4.2 4.2 0 0 1-.945.11 4.01 4.01 0 0 1-.935-7.909l39.121-9.412a4 4 0 0 1 .929-.107m0-5a9 9 0 0 0-2.063.238l-39.155 9.42a9.01 9.01 0 0 0 2.1 17.77 9.3 9.3 0 0 0 2.063-.236l.026-.006.025-.006 39.121-9.412a9.009 9.009 0 0 0-2.12-17.768",
  "data-name": "Path 25"
})), /*#__PURE__*/React.createElement("path", {
  d: "m200.676 115.942-4.756-.221-35.367-1.221a6.6 6.6 0 0 1-4.553-2.107 6.41 6.41 0 0 1-1.729-4.714 6.654 6.654 0 0 1 6.581-6.244l.108-.006 37.5 1.443 2.725.109a6.4 6.4 0 0 1 6.312 6.717 6.52 6.52 0 0 1-6.479 6.246z",
  "data-name": "Path 26",
  style: {
    fill: "#fff"
  }
}), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "m160.97 103.932 37.388 1.438 2.766.11a3.9 3.9 0 0 1 3.871 4.093 4.01 4.01 0 0 1-3.982 3.871h-.222l-4.756-.22-35.4-1.217a4.063 4.063 0 0 1-3.871-4.2 4.143 4.143 0 0 1 4.2-3.872m-.023-5-.215.01a9.114 9.114 0 0 0-8.959 8.617 8.9 8.9 0 0 0 2.392 6.539 9.06 9.06 0 0 0 6.23 2.899h.078l35.367 1.216 4.726.219h.453a9.018 9.018 0 0 0 6.53-15.2 8.9 8.9 0 0 0-6.3-2.76l-2.687-.107-37.4-1.439z",
  "data-name": "Path 27"
})), /*#__PURE__*/React.createElement("path", {
  d: "M196.478 143.488a5.4 5.4 0 0 1-.91-.089l-.152-.024h-.3l-.222-.067-39.047-9.4a6.6 6.6 0 0 1-4.124-3.055 6.35 6.35 0 0 1-.7-4.878 6.48 6.48 0 0 1 6.385-4.941 7 7 0 0 1 1.391.139l39.142 9.422a6.475 6.475 0 0 1 4.826 7.9 6.6 6.6 0 0 1-6.3 4.991",
  "data-name": "Path 28",
  style: {
    fill: "#fff"
  }
}), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M157.415 123.531a4.6 4.6 0 0 1 .9.09l29.867 7.19 9.18 2.212a3.975 3.975 0 0 1 2.987 4.867 4.12 4.12 0 0 1-3.871 3.1c-.332 0-.664-.111-1-.111L183.535 138l-27.1-6.526a4.026 4.026 0 0 1 .98-7.944m0-5a8.954 8.954 0 0 0-8.81 6.832 8.83 8.83 0 0 0 .969 6.76 9.07 9.07 0 0 0 5.649 4.2l27.142 6.537 11.947 2.876.577.139h.345a7.4 7.4 0 0 0 1.244.111 9.13 9.13 0 0 0 8.722-6.885 8.9 8.9 0 0 0-1.056-6.9 9.09 9.09 0 0 0-5.569-4.03l-9.222-2.223-29.868-7.19-.094-.022-.094-.019a9.6 9.6 0 0 0-1.882-.188",
  "data-name": "Path 29"
})), /*#__PURE__*/React.createElement("path", {
  d: "m93.519 124.98-2.814-3.614a6.392 6.392 0 0 1 5.044-10.319h18.5a6.392 6.392 0 0 1 5.044 10.319l-2.814 3.614a14.55 14.55 0 0 1-22.959 0",
  "data-name": "Path 30",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.516 97.181a2.67 2.67 0 0 1-2.673-2.673 9.363 9.363 0 0 0-18.725 0 2.672 2.672 0 1 1-5.345 0 14.708 14.708 0 0 1 29.416 0 2.67 2.67 0 0 1-2.673 2.673",
  "data-name": "Path 31",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.552 97.181a2.67 2.67 0 0 1-2.673-2.673 9.365 9.365 0 0 0-18.73 0 2.673 2.673 0 1 1-5.345 0 14.711 14.711 0 0 1 29.421 0 2.67 2.67 0 0 1-2.673 2.673",
  "data-name": "Path 32",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.974 149.049a14.727 14.727 0 0 1-14.711-14.711 2.673 2.673 0 0 1 5.346 0 9.362 9.362 0 1 0 18.725 0 2.673 2.673 0 0 1 5.345 0 14.725 14.725 0 0 1-14.705 14.711",
  "data-name": "Path 33",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.029 149.049a14.727 14.727 0 0 1-14.711-14.711 2.673 2.673 0 0 1 5.346 0 9.362 9.362 0 1 0 18.725 0 2.672 2.672 0 0 1 5.345 0 14.725 14.725 0 0 1-14.7 14.711",
  "data-name": "Path 34",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.991 137.528a2.67 2.67 0 0 1-2.673-2.673V129.6a2.673 2.673 0 0 1 5.346 0v5.257a2.67 2.67 0 0 1-2.673 2.673",
  "data-name": "Path 35",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.3 25.283 105 66.432l-6.2-41.149a13 13 0 0 1 1.991-.11c1.438 0 2.766 0 4.2.11a60 60 0 0 1 6.305 0",
  "data-name": "Path 36",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m90.779 66.457-19.137-37.1A80.4 80.4 0 0 1 83.83 26.58z",
  "data-name": "Path 37",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m138.4 29.376-9.071 17.7-9.955 19.358 6.858-39.821a90 90 0 0 1 9.518 1.987 24 24 0 0 1 2.655.774",
  "data-name": "Path 38",
  style: {
    fill: "#fff"
  }
})));
export default SvgK;